import {Message} from "primereact/message";
import {useTranslation} from "react-i18next";

import {isHouseNumberInterpolated} from "@reva/shared/geo-reference";

import AddressCard from "./AddressCard";

/**
 * Display of address details.
 * @param {PersistenceAddressData|null} addressData selected address
 * @param {(GeoRefAddress) => void} [onSelectAddress] Klick-Handler für die Adresskachel
 * @returns {React.JSX.Element|null}
 */
export default function AddressDetails({addressData, onSelectAddress}) {
    const {t} = useTranslation();

    if (!addressData) return null;

    return (
        <div>
            <AddressCard
                addressMeta={addressData.address}
                isReferenceAddress={addressData.hasReferenceAddress}
                referenceAddressComment={addressData.referenceAddressComment}
                onSelectAddress={onSelectAddress}
            />
            {isHouseNumberInterpolated(addressData.address) && (
                <Message
                    severity="info"
                    icon="pi pi-map-marker"
                    test-key="address-housenumber-interpolated"
                    text={t("address.housenumber_interpolated")}
                    className="w-full justify-start mt-2 leading-normal"
                />
            )}
        </div>
    );
}
